import { message, Spin, Tabs } from "antd";
import CommonDivWidget from "components/CommonDivWidget/CommonDivWidget";
import { useEffect } from "react";
import { useState, React } from "react";
import "./TeamPage.css";
import TeamMemberPage from "./TeamMemberPage/TeamMemberPage";
import SalaryPage from "./SalaryPage/SalaryPage";
import SalaryByMonthPage from "./SalaryByMonthPage/SalaryByMonthPage";

function TeamPage() {
  const [isBusy, setIsBusy] = useState(false);
  const [reloadTab3, setReloadTab3] = useState(0);

  const tabList = [
    {
      key: "tab1",
      label: "All Members",
      children: <TeamMemberPage/>,
    },
    {
      key: "tab2",
      label: "All Salary",
      children: <SalaryPage/>,
    },
    {
      key: "tab3",
      label: "Salary By Month",
      children: <SalaryByMonthPage reload_random={reloadTab3}/>,
    },
  ];

  useEffect(() => {
    
  }, []);

  const changeTab = (activeKey) => {
    if (activeKey === "tab3") {
      setReloadTab3(Math.floor(Date.now()))
    }
  };

  return (
    <CommonDivWidget>
      <Spin spinning={isBusy}>
        <Tabs defaultActiveKey="tab1" type="card" items={tabList} onChange={changeTab}/>
      </Spin>
    </CommonDivWidget>
  );
}

export default TeamPage;
